import { Coords } from '@vromo/models';
import { optional } from '@vromo/models';

import { createModelSchema, primitive, object } from 'serializr';

export class Point {
    id: number | null = null;
    created: number | null = null;
    heading: number | null = 0;
    location: Coords | null = null;
    reported: number | null = null;
    speed: number | null = null;
    subject: number | null = null;
}

createModelSchema(Point, {
    id: optional(primitive()),
    created: optional(primitive()),
    heading: optional(primitive()),
    location: optional(object(Coords)),
    reported: optional(primitive()),
    speed: optional(primitive()),
    subject: optional(primitive())
});
